import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchDeletePortfolioComapny,
  fetchDeletePortfolioTeam,
  fetchingPortfolioComapnyJson,
  fetchPortfolioCompanyDetails,
  fetchPortfolioTeamDetails,
  updatingPortfolioComapny,
  updatingPortfolioTeam,
} from '../Slice/FundActions';

export const getPorfolioCompany = createAsyncThunk(
  'fundManager/getPortfolioCompany',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } =
        await fetchPortfolioCompanyDetails(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getPortfolioTeams = createAsyncThunk(
  'funds/getPortfolioTeams',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchPortfolioTeamDetails(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePortfolioComapny = createAsyncThunk(
  'portfolioCompany/updateDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await updatingPortfolioComapny(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePortfolioTeam = createAsyncThunk(
  'PortfolioTeam/updateDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await updatingPortfolioTeam(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePortfolioComapny = createAsyncThunk(
  'portfolioCompany/deleteDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchDeletePortfolioComapny(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePortfolioTeam = createAsyncThunk(
  'portfolioTeam/deleteDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchDeletePortfolioTeam(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePortfolioComapnyJson = createAsyncThunk(
  'portfolioCompany/updateDetailsJson',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } =
        await fetchingPortfolioComapnyJson(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
